<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2022-01-12 17:38:35
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-23 15:10:52
-->
<template>
  <div class="content">
    <div class="top-info">
      <span class="cell number">
        <i
          class="iconfont icon-dingdanbianhao"
          style="font-size: 20px; margin-right: 5px"
        ></i>
        订单编号：{{ detail.orderNum }}
      </span>
      <span class="cell">委托方：{{ detail.client }}</span>
      <span class="cell">订单类型：{{ detail.orderTypeName }}</span>
    </div>
    <el-table
      class="table-machine-info"
      :data="info"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="cropIdName"
        label="种植作物"
        min-width="10%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="orderTime"
        label="作业时间要求"
        min-width="22%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="workTypeNames"
        label="作业类型"
        min-width="18%"
        align="center"
        :resizable="false"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="orderAmount"
        label="订单总额（元）"
        min-width="16%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="workAmountTotal"
        label="应付作业金额（元）"
        min-width="16%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="settleAmout"
        label="已结算金额（元）"
        min-width="16%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        prop="unSettleAmout"
        label="未结算金额（元）"
        min-width="16%"
        align="center"
        :resizable="false"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "DetailTopPart",
  data() {
    return {
      detail: {},
      info: [],
    };
  },
  props: {
    orderId: {
      type: String,
    },
  },
  mounted() {
    this.getOrderSettleDetail();
  },
  methods: {
    /**
     * @descripttion: 获取订单详情
     * @Author: juanjuanhui
     * @Date: 2021-11-25 10:45:30
     * @param {*}
     */
    getOrderSettleDetail() {
      this.$http.village
        .getOrderSettleDetail({ id: this.orderId })
        .then((res) => {
          this.detail = res.data;
          this.info = [res.data];
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  .top-info {
    display: flex;
    align-items: center;
    padding-top: 10px;
    color: #018388;
    .cell {
      display: flex;
      align-items: center;
      margin-right: 4%;
      &.number {
        font-weight: 900;
      }
    }
  }
  ::v-deep .el-table {
    &.table-machine-info {
      margin-top: 20px;
    }
    thead {
      color: #5f6868;
      .el-table__cell {
        font-weight: normal;
        background-color: #f1f5f8;
      }
    }
  }
}
</style>
